import { Immutable } from "immer";
import React from "react";

type IProps = Immutable<{
    className: string;
    heading: string;
    isCurrentStep?: boolean;
    children?: React.ReactNode;
}>;

export const CheckoutStep = (props: IProps): React.JSX.Element => {
    return (
        <div
            role="group"
            className={`checkout-step ${props.className}`}
            aria-label={props.heading}
        >
            <h2
                className="checkout-step__heading"
                aria-current={props.isCurrentStep ? "step" : false}
            >
                {props.heading}
            </h2>
            {props.children}
        </div>
    );
};
